/**
 * @generated SignedSource<<c0730aa637134689e1577dfa4d5fc6e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomebasePartners_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomebasePartners_partnerLocations" | "HomebasePartners_partners">;
  readonly " $fragmentType": "HomebasePartners_query";
};
export type HomebasePartners_query$key = {
  readonly " $data"?: HomebasePartners_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomebasePartners_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomebasePartners_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomebasePartners_partnerLocations"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomebasePartners_partners"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3ab613f21891301b8ba76d5a27b0aead";

export default node;
